//startup settings
function startup(klevu) {
  const apiKey = 'klevu-159723802714912608';

  var options = {
    url          : {
      search      : klevu.settings.url.protocol + '//eucs21v2.ksearchnet.com/cs/v2/search',
      landing     : '/search',
      protocolFull: klevu.settings.url.protocol + '//'
    },
    localSettings: true,
    search       : {
      searchBoxSelector    : 'input.js-search-bar__input',
      searchBoxTarget      : false,
      minChars             : 3,
      placeholder          : 'Search',
      showQuickOnEnter     : false,
      fullPageLayoutEnabled: false,
      personalisation      : true,
      redirects            : [],
      apiKey               : apiKey
    },
    analytics    : {
      apiKey: apiKey
    }
  };

  klevu(options);
}

klevu.interactive(function () {
  startup(klevu);

  const loader = document.querySelector('.js-search-loader');

  if (document.body.contains(loader)) {
    loader.style.display = 'none';
  }
});

klevu.coreEvent.build({
  name    : 'bindLocalBoxes',
  fire    : function () {
    if (!klevu.isInteractive || klevu.isUndefined(klevu.search) || klevu.isUndefined(klevu.search.build) || klevu.isUndefined(klevu.searchEvents) || klevu.isUndefined(klevu.searchEvents.functions) || klevu.isUndefined(klevu.searchEvents.functions.bindAllSearchBoxes)) {
      return false;
    }
    return true;
  },
  maxCount: 500,
  delay   : 30
});
//attach to all search boxes on the page
klevu.coreEvent.attach('bindLocalBoxes', {
  name: 'search-boxes-local-boxes',
  fire: function () {
    klevu.searchEvents.functions.bindAllSearchBoxes.fire();
  }
});
